type Predicate<T> = (value: T) => boolean;

export const and =
  <T>(...predicates: Predicate<T>[]): Predicate<T> =>
  (value: T) =>
    predicates.every((pred) => pred(value));

export const or =
  <T>(...predicates: Predicate<T>[]): Predicate<T> =>
  (value: T) =>
    predicates.some((pred) => pred(value));

export const not =
  <T>(predicate: Predicate<T>): Predicate<T> =>
  (value: T) =>
    !predicate(value);

export const any =
  <T>(predicate: Predicate<T>) =>
  (values: T[]): boolean =>
    values.some(predicate);
